<div class="topNavigationCalendar">
    <i (viewDateChange)="closeOpenMonthViewDay()" [(viewDate)]="viewDate" [view]="view"
       class="material-icons leftChevron"
       id="cal-prev"
       mwlCalendarPreviousView>
        chevron_left
    </i>
    <div class="currentMonth">
        <h3 style="font-size: 25px;">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
    </div>
    <i (viewDateChange)="closeOpenMonthViewDay()" [(viewDate)]="viewDate" [view]="view"
       class="material-icons rightChevron"
       id="cal-next"
       mwlCalendarNextView>
        chevron_right
    </i>
</div>
<div class="view"></div>
<div class="calendar">
    <div [ngSwitch]="view">
        <mwl-calendar-month-view
                (dayClicked)="dayClicked($event.day)"
                (eventClicked)="handleEvent('Clicked', $event.event)"
                *ngSwitchCase="CalendarView.Month"
                [activeDayIsOpen]="activeDayIsOpen"
                [events]="events"
                [refresh]="refresh"
                [viewDate]="viewDate"
        >
        </mwl-calendar-month-view>
        <mwl-calendar-week-view
                (eventClicked)="handleEvent('Clicked', $event.event)"
                *ngSwitchCase="CalendarView.Week"
                [events]="events"
                [refresh]="refresh"
                [viewDate]="viewDate"

        >
        </mwl-calendar-week-view>
        <mwl-calendar-day-view
                (eventClicked)="handleEvent('Clicked', $event.event)"
                *ngSwitchCase="CalendarView.Day"
                [events]="events"
                [refresh]="refresh"
                [viewDate]="viewDate"
        >
        </mwl-calendar-day-view>
    </div>
</div>
<div kendoDialogContainer></div>

